export const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';

export const VIZ_CHART_COLORS = [
  '#067bc4',
  '#aa44c9',
  '#f07651',
  '#2ecc71',
  '#e74c3c',
  '#f1c40f',
  '#1abc9c',
  '#e67e22',
];
